import React, { useState, useEffect } from "react";
import ContactForm from "./components/ContactForm";
import { Box } from "@mui/material";
import DirectorNavbar from "./navigation";
import NavigationTalent from "./talent/NavigationTalent";
import Navbar from "./admin/AdminNav";
import NonLoggedInNavbar from "./landing/components/PublicNavbar";
import GlobalNotification from "./components/GlobalNotification";
import Footer from "./Footer";

function Contact() {
  const [userId, setUserId] = useState(null);

  const userRole = localStorage.getItem("userRole");

  const isDirector = userRole === "COMPANY";
  const isTalent = userRole === "USER";
  const isAdmin = userRole === "ADMIN";

  useEffect(() => {
    const id = localStorage.getItem("userId");

    if (id) {
      setUserId(id);
    }
  }, []);

  const renderNavbar = () => {
    if (isDirector) return <DirectorNavbar />;
    if (isTalent) return <NavigationTalent />;
    if (isAdmin) return <Navbar />;
    return <NonLoggedInNavbar />;
  };

  return (
    <>
      {renderNavbar()}

      {/* Disable banners for admin */}
      {!isAdmin && userId && (
        <GlobalNotification userId={userId} userRole={userRole} />
      )}

      <Box sx={{ background: "#eeeeee", py: 3 }}>
        <ContactForm />
      </Box>

      <Footer />
    </>
  );
}

export default Contact;